<script setup lang="ts">

import Drawer from 'primevue/drawer'
import CustomButton from '@/components/UI/CustomButtom/CustomButton.vue'
import { useI18n } from 'vue-i18n'
import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'

const { t } = useI18n()
const route = useRoute()

const visibleBottomDrawer = ref(false);
const notificationDrawer = ref(false)

const tabList = ref([
  { route: "/?audience=woman", label: "audience.women", audience:'woman', checked: false },
  { route: "/?audience=man", label: "audience.men",  audience:'man', checked: false },
  { route: "/?audience=kids", label: "audience.kids", audience:'kids', checked: false },
  { route: "/?audience=home", label: "audience.home", audience:'home', checked: false },
]);


const currentAudienceLabel = computed(() => tabList.value.find(item => item.checked)?.label)

watch(() => route.query.audience, () => {
  if(route.query.audience) {
    tabList.value = tabList.value.map(tabValue => {
      return {
        ...tabValue,
        checked: route.query.audience === tabValue.audience
      }
    })
  } else {
    // default woman audience if no audience
    tabList.value[0].checked = true
  }
},{
  deep: true,
  immediate: true,
})

</script>

<template>
  <div class="mobile-header-menu">
    <router-link to="/" class="mobile-logo">
    </router-link>

    <div class="mobile-tabs">
      <CustomButton :label="t(`${currentAudienceLabel}`)" severity="success"
                    @click="visibleBottomDrawer = true" rounded
                    class="text-color"
      />
      <Drawer v-model:visible="visibleBottomDrawer" header="Choose" position="bottom" style="height: auto" :pt="{
          root:{
            style:{
              borderTopLeftRadius:'40px',
              borderTopRightRadius:'40px',
            }
          },
          header:{
            class:'title',
            style:{
              justifyContent:'flex-end',
              gap:'44%'
            }
          }
        }">
        <ul class="tabs-list">
          <li v-for="tabItem in tabList" class="tab-item-container">
            <router-link :to="tabItem.route" class="tabs-link-item body-small">
              {{t(`${tabItem.label}`) }}
            </router-link>
            <i v-if="tabItem.checked" class="pi pi-check body-small" />
          </li>
        </ul>
      </Drawer>
    </div>

    <div class="mobile-actions">
      <CustomButton icon="pi pi-bell" severity="success"
                    @click="notificationDrawer = true" rounded
                    class="icon-color"
      />

      <Drawer v-model:visible="notificationDrawer" header="Notifications"
              position="bottom" style="height: 100vh"
              :pt="{
                content:{
                  style:{
                    display:'flex',
                    flexDirection:'column',
                    gap:'20px'
                  }
                }
              }"

      >
        <div v-for="item in 4" class="notification-item">
          <span class="title">Notification Id</span>
          <span class="body-bold">Notification title</span>
          <div class="body-underlined">
            Polo is inder <b>60$</b>
          </div>
        </div>
      </Drawer>

    </div>

  </div>
</template>

<style scoped>

.mobile-header-menu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height:60px;
  max-height: 60px;
  position: fixed;
  top:0;
  z-index: 10;
  background: transparent;
  padding: 0 16px;
  backdrop-filter: blur(3px);
}

.mobile-logo {
  height:100%;
  max-height: 60px;
  max-width: 60px;
  width:60px;
  background-image: url('@/assets/img/mobileLogo.svg');
}


.text-color {
  color:var(--primary-blue-100)
}


.icon-color {
  color:var(--active-100)
}


ul, ol {
  list-style: none; /* Убирает маркеры/нумерацию */
  margin: 0;       /* Убирает внешние отступы */
  padding: 0;      /* Убирает внутренние отступы */
}

.tabs-list {
  padding:16px;
}

.tabs-link-item {
  height:100%;
  width:98%;
  color:var(--primary-blue-80);
}

.tab-item-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding:12px 20px;
}


.notification-item {
  display:flex;
  flex-direction: column;
  gap:10px;
  border:1px dashed var(--primary-blue-100);
  padding:20px;
  border-radius: 20px;
}

a {
  text-decoration: none; /* Убирает подчеркивание */
  color: inherit;       /* Наследует цвет текста от родителя */
}

</style>